export const PATIENT_HOME_KEYS = {
  all: ['patientHome'] as const,
  byUser: (userid: string | number) => [...PATIENT_HOME_KEYS.all, String(userid)] as const,
} as const;
